import React, { useState } from "react";
import configData from "../../config.json";
import {
  AppBar,
  Button,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useNavigate, useParams } from "react-router-dom";

function MissingReportHeader({
  devices,
  getMissingDevicesRequest,
  handleNetworkUpdateClick,
}) {
  const params = useParams();
  const navigate = useNavigate();
  //Action menue for multi select:
  const [anchorElUser, setAnchorElUser] = useState(null);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const moveToMultiPhotoes = () => {
    const tempSerialNumbers = devices.map((item) => item.serial_number);
    let serials_string = JSON.stringify(tempSerialNumbers);
    let serials_url = btoa(serials_string);
    navigate(
      `/Multi/Photos/` +
        serials_url +
        "/" +
        params.retailer +
        "/" +
        params.store
    );
  };
  //Move to wifi report
  const moveToWifiReport = () => {
    const tempSerialNumbers = devices.map((item) => item.serial_number);
    let serials_string = JSON.stringify(tempSerialNumbers);
    let serials_url = btoa(serials_string);
    navigate(
      `/Multi/WiFi-Report/` +
        serials_url +
        "/" +
        params.retailer +
        "/" +
        params.store
    );
  };

  return (
    <AppBar position="static" color="primary">
      <Toolbar>
        <Typography
          variant="h6"
          noWrap
          component="div"
          sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }}
          onClick={() => {
            navigate("/Home/" + params.retailer + "/" + params.store);
          }}
        >
          Home
        </Typography>
        <Box>
          <Box sx={{ display: "flex" }}>
            <Tooltip title="Open Menu">
              <Button
                onClick={handleOpenUserMenu}
                sx={{ color: "white" }}
                variant="contained"
              >
                Actions
                <ArrowDropDownIcon />
              </Button>
            </Tooltip>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              <MenuItem onClick={handleCloseUserMenu}>
                <Typography textAlign="center" onClick={moveToMultiPhotoes}>
                  Camera
                </Typography>
              </MenuItem>
              <MenuItem onClick={handleCloseUserMenu}>
                <Typography textAlign="center" onClick={moveToWifiReport}>
                  WiFi Report
                </Typography>
              </MenuItem>
              <MenuItem onClick={handleCloseUserMenu}>
                <Typography
                  textAlign="center"
                  onClick={handleNetworkUpdateClick}
                >
                  Networks update
                </Typography>
              </MenuItem>
              <MenuItem onClick={handleCloseUserMenu}>
                <Typography
                  textAlign="center"
                  onClick={getMissingDevicesRequest}
                >
                  Query update
                </Typography>
              </MenuItem>
            </Menu>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default MissingReportHeader;
